module.exports = __webpack_public_path__ + "static/img/7.-USB-Cable.a9435c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/7.-USB-Cable.jpg
// module id = mjQp
// module chunks = 1